import { render, staticRenderFns } from "./DeleteTournament.vue?vue&type=template&id=704124b4&scoped=true"
import script from "./DeleteTournament.vue?vue&type=script&lang=js"
export * from "./DeleteTournament.vue?vue&type=script&lang=js"
import style0 from "./DeleteTournament.vue?vue&type=style&index=0&id=704124b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704124b4",
  null
  
)

export default component.exports